<template>
  <div class="modal-central" :class="{'visible': $attrs['config']['visible'], 'no-sidebar': !$attrs['config']['showSidebar']}" v-if="$attrs['config']['visible']">
    <div class="d-flex h-100 mh-100 justify-content-center align-items-center">
      <div class="box align-items-center" v-click-outside="clickOutside">
        <div class="sidebar" v-if="$attrs['config']['showSidebar']">
          <div class="content">
            <img src="@/assets/images/val.png" width="75" class="mb-2" alt="Val - Fundador do Consulta Já">
            <p class="name">Val - Fundador do Consulta Já</p>

            <p class="text">Olá! Eu sou o Val do Consulta Já e vou ajudar você encontrar o que procura em nosso sistema. Vamos lá? ;)</p>

<!--            <p class="left" @click="() => closeModal(true)">Não ver mais</p>-->
<!--            <p class="right" @click="() => closeModal(false)"><i class="fa fa-times"></i></p>-->
          </div>

          <div class="options">
            <p>Escolha o que você deseja fazer:</p>

            <p class="option sec" @click="() => performAction('add-secretary')">Adicionar Secretária</p>
            <p class="option" @click="() => performAction('see-agenda')">Ver Agenda</p>
          </div>
        </div>

        <div class="area">
          <div class="content text-center">
            <div class="simulation-content" v-if="$attrs['config']['content'] == 'simulation'">
<!--              <p class="left" @click="() => closeModal(true)">Não ver mais</p>-->
              <p class="right" @click="() => closeModal(false)"><i class="fa fa-times"></i></p>
              <img src="https://cdn.dribbble.com/users/2030807/screenshots/6927076/mobile-hand-msg.gif" :width="($attrs['config']['showSidebar'])?'40%':'80%'" alt="">
              <p class="title">Nós ajudamos a resolver seu problema de confirmação de consultas e perda de horários, enviando lembretes automáticos pelo Whatsapp. Veja como funciona na prática:</p>
              <button class="" :class="{'waiting': simulationStatus == 'waiting', 'warning': simulationStatus == 'check'}" @click="requestSimulation" v-if="simulationStatus == 'waiting' || simulationStatus == 'check'">{{ (simulationStatus == 'waiting')?'Clique aqui e Simule Agora':'Não recebeu nossa mensagem? Clique aqui para receber novamente.' }}</button>
              <button class="sending" :class="{'sending': simulationStatus == 'sending', 'sended': simulationStatus == 'sended'}" v-else> {{ (simulationStatus == 'sending')?'Enviando mensagem para '+user.person.cellphone+'...':'Mensagem enviada, verifique seu celular.'}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalCentral',
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      simulationStatus: 'waiting'
    }
  },
  watch: {
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'));
  },
  methods: {
    clickOutside(event) {
      if(!event.target.classList.contains('sidebar') && !event.target.classList.contains('waiting') && !event.target.classList.contains('sending') && !event.target.classList.contains('sended') && !event.target.classList.contains('swal-button'))
        this.closeModal(false);
    },

    closeModal(forever) {
      if(forever) {
        // TODO
      }

      this.eventBus.$emit('CLOSE_MODAL');
    },
    performAction(action) {
      if(action == 'add-secretary') {
        if(this.$route.path != '/secretarias/cadastrar-secretaria')
          this.$router.push({ path: '/secretarias/cadastrar-secretaria' }).catch(() => {});

        this.closeModal(false);
      } else if(action == 'see-agenda') {
        if(this.$route.path != '/')
          this.$router.push({ path: '/' }).catch(() => {});

        this.closeModal(false);
      } else if(action == 'schedule-appointment') {
        this.$router.push({ path: '/' }).catch(() => {});
      }
    },
    requestSimulation() {
      let previousStatus = JSON.parse(JSON.stringify(this.simulationStatus));

      this.simulationStatus = 'sending';
      this.api.requestSimulation().then(res => {
        this.simulationStatus = 'sended';
        if(res.data.success) {
          // TODO send events

          if(previousStatus == 'waiting')
            setTimeout(() => { this.simulationStatus = 'check'; }, 15000);
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Request Simulation', res);
      }).catch(err => {
        let msg = 'Não conseguimos enviar a simulação! Por favor, entre em contato com o suporte!';

        if(err.response.status == 400 && typeof err.response.data.error != 'undefined')
          msg = err.response.data.error;

        this.$swal('Ops...', msg, 'error');

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Request Simulation', err.response);
      });
    }
  }
}
</script>

<style scoped lang="scss">
  .modal-central {
    background-color: rgba(0,0,0,0.75);
    width: 100%;
    height: 0;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0;
    transition: all 0.5s;
    z-index: 1000;

    p {
      margin: 0;
    }

    &.visible {
      height: 100%;
      opacity: 1;
      scroll-behavior: unset;
    }

    .left {
      font-size: 0.8em;
      position: absolute;
      top: 20px;
      left: 20px;
      cursor: pointer;
      transition: all 0.5s;
      color: $cadetGray;

      &:hover {
        color: $linkWater;
      }
    }

    .right {
      font-size: 0.8em;
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
      transition: all 0.5s;
      color: $cadetGray;

      &:hover {
        color: $linkWater;
      }
    }

    .box {
      display: flex;
      max-width: 750px;
      flex-flow: column;

      .sidebar {
        width: 90%;
        border-radius: 0 0 15px 15px;
        flex: 1;
        order: 2;
        display: flex;
        background: rgba(33,44,59,1);
        background: -moz-linear-gradient(left, $tangaroa 0%, $tangaroa 50%, rgba(255,255,255,1) 50%, rgba(255,255,255,1) 100%);
        background: -webkit-gradient(left top, right top, color-stop(0%, $tangaroa), color-stop(50%, $tangaroa), color-stop(50%, rgba(255,255,255,1)), color-stop(100%, rgba(255,255,255,1)));
        background: -webkit-linear-gradient(left, $tangaroa 0%, $tangaroa 50%, rgba(255,255,255,1) 50%, rgba(255,255,255,1) 100%);
        background: -o-linear-gradient(left, $tangaroa 0%, $tangaroa 50%, rgba(255,255,255,1) 50%, rgba(255,255,255,1) 100%);
        background: -ms-linear-gradient(left, $tangaroa 0%, $tangaroa 50%, rgba(255,255,255,1) 50%, rgba(255,255,255,1) 100%);
        background: linear-gradient(to right, $tangaroa 0%, $tangaroa 50%, rgba(255,255,255,1) 50%, rgba(255,255,255,1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#212c3b', endColorstr='#ffffff', GradientType=1 );
        -webkit-box-shadow: inset 0px 20px 25px -6px rgba(0,0,0,0.5);
        -moz-box-shadow: inset 0px 20px 25px -6px rgba(0,0,0,0.5);
        box-shadow: inset 0px 20px 25px -6px rgba(0,0,0,0.5);

        .content {
          padding: 20px;
          text-align: center;
          position: relative;

          img {
            border-radius: 50%;
            border: 4px solid #ffffff;
          }

          .name {
            font-weight: bold;
            margin-bottom: 15px;
            color: $pictionBlue;
          }

          .text {
            font-weight: bold;
            color: #ffffff;
          }
        }

        .options {
          width: 100%;
          border-radius: 0 0 15px 15px;
          padding: 20px 40px;
          text-align: center;
          display: flex;
          flex-flow: column;
          justify-content: center;

          p:not(.option) {
            margin: 10px 0;
          }

          .option {
            width: 100%;
            display: inline-block;
            padding: 10px;
            background-color: $tangaroa;
            text-transform: uppercase;
            color: #ffffff;
            text-decoration: none;
            margin: 10px 0;
            border-radius: 5px;
            font-weight: bold;
            cursor: pointer;
            transition: all 0.5s;

            &:hover {
              transform: scale(1.1);
            }

            &.sec {
              background-color: $pictionBlue;
            }
          }
        }
      }

      .area {
        width: auto;
        height: auto;
        flex: 1;

        .content {
          height: 100%;
          background-color: #FFFFFF;
          border-radius: 15px;
          position: relative;

          .simulation-content {
            padding: 25px;
            border-radius: 0 15px 0 0;
            text-align: center;

            img {
              margin-bottom: 20px;
            }

            .title {
              font-size: 1.2em;
              color: $tangaroa;
              font-weight: bold;
              text-align: center;
              margin-bottom: 5px;
            }

            .subtitle {
              font-size: 0.9em;
              color: $tangaroa;
              font-weight: bold;
              text-align: center;
              margin-bottom: 5px;
            }

            button {
              background-color: #25D366;
              color: #FFFFFF;
              text-transform: uppercase;
              font-weight: bold;
              font-size: 1em;
              padding: 10px;
              border-radius: 5px;
              margin-top: 10px;
              cursor: pointer;
              transition: all 0.5s;

              &:hover {
                transform: scale(1.1);
              }

              &.sending {
                cursor: default;
                background-color: $tangaroa;
                box-shadow: 0 0 0 rgba(204,169,44, 0.4);
                transition: all 0.5s;
                animation: pulse 2s infinite;

                @-webkit-keyframes pulse {
                  0% {
                    -webkit-transform: scale(1.00);
                    -webkit-box-shadow: 0 0 0 0 rgba(33, 44, 59, 0.4);
                  }
                  70% {
                    -webkit-transform: scale(1.05);
                    -webkit-box-shadow: 0 0 0 10px rgba(33, 44, 59, 0);
                  }
                  100% {
                    -webkit-transform: scale(1.00);
                    -webkit-box-shadow: 0 0 0 0 rgba(33, 44, 59, 0);
                  }
                }
                @keyframes pulse {
                  0% {
                    -moz-transform: scale(1.00);
                    transform: scale(1.00);
                    -moz-box-shadow: 0 0 0 0 rgba(33, 44, 59, 0.4);
                    box-shadow: 0 0 0 0 rgba(33, 44, 59, 0.4);
                  }
                  70% {
                    -moz-transform: scale(1.05);
                    transform: scale(1.05);
                    -moz-box-shadow: 0 0 0 10px rgba(33, 44, 59, 0);
                    box-shadow: 0 0 0 10px rgba(33, 44, 59, 0);
                  }
                  100% {
                    -moz-transform: scale(1.00);
                    transform: scale(1.00);
                    -moz-box-shadow: 0 0 0 0 rgba(33, 44, 59, 0);
                    box-shadow: 0 0 0 0 rgba(204,169,44, 0);
                  }
                }

                &:hover {
                  transform: none;
                }
              }

              &.sended {
                cursor: default;
                background-color: $ufoGreen;

                &:hover {
                  transform: none;
                }
              }

              &.warning {
                background-color: $supernova;
              }
            }
          }

          .videos-content {
            padding: 25px;
            height: 100%;

            .title {
              font-size: 1.5em;
              color: $tangaroa;
              text-transform: uppercase;
              font-weight: bold;
              text-align: center;
              margin-bottom: 20px;
            }
          }

          .scroll {
            height: 95%;
            overflow: scroll;
            display: flex;
            flex-wrap: wrap;
            text-align: center;
            padding-left: 10px;

            &::-webkit-scrollbar {
              -webkit-appearance: none;
            }

            &::-webkit-scrollbar:vertical {
              width: 10px;
            }

            &::-webkit-scrollbar-thumb {
              border-radius: 15px;
              border: 2px solid white;
              background-color: $tangaroa;
            }

            .video {
              flex: 1 0 45%;
              padding: 0 15px;
              margin-bottom: 15px;

              .video-title {
                width: 100%;
                padding: 10px 15px;
                font-weight: bold;
                color: $tangaroa;
                border-radius: 0 0 15px 15px;
                margin-top: -4px;
                text-transform: uppercase;
                border: 1px solid $tangaroa;
              }

              iframe {
                width: 100% !important;
                height: auto !important;
              }
            }
          }
        }
      }
    }

    &.no-sidebar {
      .box {
        .area {
          .content {
            border-radius: 25px;
            box-shadow: none;
          }
        }
      }
    }
  }

  @media (max-width: 767px) {
    .modal-central {
      .box {
        width: 80%;
      }
    }
  }
</style>
